export default __webpack_public_path__ + "static/media/addFolder.4a6c039b.svg";